import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import Dropdown from '../../Dropdown';

import Icon from '../../Icon';
import createLink from "../../../../libs/createLink";
import CtaCannot from "../../CtaCannot";
import moment from "moment";



const FakeNotificationsList = (props) =>{

    return (
        <Fragment>
            <div className="notifications-list" onClick={props.handleCloseDropdown}>
                {props.notificationTotal === 0 ? (
                        <div className="no-content">Aucune notification pour le moment</div>
                    ) :
                    props.notifications.map((notification, index) => (
                        <a
                            key={index}
                            href={notification.linkTo}
                            target={"_blank"}
                            className={"notification-item unread"}
                            rel="noopener noreferrer noindex nofollow"
                        >
                            <div className="content">
                                {notification.title}.
                            </div>
                            <div className="sub">
                                <Icon type={notification.icon}/>
                                <span className="date">
                                    {moment(notification.createdAt).fromNow()}
                                </span>
                            </div>
                        </a>
                    ))
                }

            </div>
            <div className="see-more-notifications" onClick={props.handleCloseDropdown}>
                <Link to="/notifications">Voir toutes les notifications</Link>
            </div>
        </Fragment>
    )
}


class FakeNotifications extends React.Component {
    constructor(props) {
        super(props);
        this.timeoutScenario = null;
        this.intervalSteep = [0,5,3,32,20];// interval entre chaque steep

        // on recupere le scenario enregistre si present sinon init
        let scenario = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_notifications_pub`)) || {
            currentScenario : Math.floor(Math.random() * 1e9) % 2,
            currentSteep : 0,
            scenarioCreatedAt : new Date()
        };

        this.source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "voissa";

        //on prepare les scenarios et steep
        this.listScenario = [
            {
                notifications : {
                    0 : [],
                    1 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}],
                    2 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}, {icon : "notif-rencontre", title : <Fragment>Nos conseils pour faire des <b>rencontres coquines</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2a"}],
                    3 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}, {icon : "notif-rencontre", title : <Fragment>Nos conseils pour faire des <b>rencontres coquines</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2a"}],
                    4 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}, {icon : "notif-rencontre", title : <Fragment>Nos conseils pour faire des <b>rencontres coquines</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2a"}, {icon : "notif-chat", title : <Fragment>Voir des filles <b>dans ta région</b> qui veulent chatter</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[4], 'seconds'), linkTo : "https://tracker.snaping.net/index.php?key=3vpgzn96uz7riniiqdis&t=notif-dating&source=notifications_guests&spot=notif_3a"}]
                },
                messenger : {
                    0 : 0,
                    1 : 0,
                    2 : 0,
                    3 : 1,
                    4 : 1
                }
            },
            {
                notifications : {
                    0 : [],
                    1 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}],
                    2 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}, {icon : "notif-rencontre", title : <Fragment>Les <b>meilleurs sites de plans cul</b> par Voissa</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2b"}],
                    3 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}, {icon : "notif-rencontre", title : <Fragment>Les <b>meilleurs sites de plans cul</b> par Voissa</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2b"}],
                    4 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}, {icon : "notif-rencontre", title : <Fragment>Les <b>meilleurs sites de plans cul</b> par Voissa</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2b"}, {icon : "notif-chat", title : <Fragment>Trouve un plan cul <b>pour ce soir</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(this.intervalSteep[4], 'seconds'), linkTo : "https://tracker.snaping.net/index.php?key=3vpgzn96uz7riniiqdis&t=notif-dating&source=notifications_guests&spot=notif_3c"}]
                },
                messenger : {
                    0 : 0,
                    1 : 0,
                    2 : 0,
                    3 : 1,
                    4 : 1
                }
            }
        ];

        //si le currentScenario et superieur au maximum on init
        if(scenario.currentScenario > this.listScenario.length - 1){
            scenario = {
                ...scenario,
                currentSteep : 0,
                currentScenario : Math.floor(Math.random() * 1e9) % 2
            }
            localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_notifications_pub`, JSON.stringify({currentScenario : scenario.currentScenario ,currentSteep :  scenario.currentSteep, scenarioCreatedAt : scenario.scenarioCreatedAt }));
        }
        //si le steep et superieur on le repasse a 0
        if(scenario.currentSteep > this.intervalSteep.length - 1){
            scenario = {
                ...scenario,
                currentSteep : 0
            }
            localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_notifications_pub`, JSON.stringify({currentScenario : scenario.currentScenario ,currentSteep :  scenario.currentSteep, scenarioCreatedAt : scenario.scenarioCreatedAt }));
        }
        this.state = {
            ...scenario,
            messengerClass : "",
            notificationClass : ""
        };
        this.generateScenario = this.generateScenario.bind(this);

    }

    componentDidMount() {
        //une fois le component charger on demarre le scenario
        this.generateScenario();
    }

    componentWillUnmount() {
        //on clear le timeout en quittant le component
        clearTimeout(this.timeoutScenario);
    }

    componentDidUpdate(prevProps, prevState) {
        //si il y a un changement de steep on ajoute une class qu'on retire une seconde apres
        if(prevState.currentSteep !== this.state.currentSteep){
            let prevSteep = this.getScenario(prevState.currentSteep);
            let currentSteep = this.getScenario(this.state.currentSteep);

            if(prevSteep.notifications.length !== currentSteep.notifications.length){
                this.setState({
                    notificationClass : "notification_appearing"
                });
                setTimeout(() => {
                    this.setState({
                        notificationClass : ""
                    });
                },1000);
            }
            if(prevSteep.messenger !== currentSteep.messenger){
                this.setState({
                    messengerClass : "notification_appearing"
                });
                setTimeout(() => {
                    this.setState({
                        messengerClass : ""
                    });
                },1000);
            }

        }
    }

    generateScenario(){
        let totalSteep = this.intervalSteep.length - 1;
        let currentSteep = this.state.currentSteep;
        let currentScenario = this.state.currentScenario;
        let nextCurrentSteep = currentSteep + 1;
        nextCurrentSteep = nextCurrentSteep <= totalSteep ? nextCurrentSteep : totalSteep;


        if(nextCurrentSteep <= totalSteep) {
            this.timeoutScenario = setTimeout(() => {
                this.setState({currentSteep : nextCurrentSteep}, ()=>{
                    localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_notifications_pub`, JSON.stringify({currentScenario, currentSteep :  nextCurrentSteep, scenarioCreatedAt : this.state.scenarioCreatedAt }));
                })
                if(nextCurrentSteep < totalSteep) {
                    this.generateScenario();
                }
            }, (this.intervalSteep[nextCurrentSteep] * 1000));
        }
        else{
            clearTimeout(this.timeoutScenario);
        }

    }

    getScenario(currentSteep){
        let currentScenario = this.state.currentScenario || 0;
        let scenario = this.listScenario[currentScenario] || {};
        return {
            notifications : scenario?.notifications[currentSteep] || [],
            messenger : scenario?.messenger[currentSteep] || 0
        };
    }


    render() {

        let notifications = this.getScenario(this.state.currentSteep).notifications;
        let notificationsTotal = notifications.length;
        let messengerTotal = this.getScenario(this.state.currentSteep).messenger;

        return (
            !this.props.currentUserInitialized && !this.props.currentUserLoading && this.source !=="nouslib" ? (
                <Fragment>
                    <CtaCannot
                        action={"chatWebcam"}
                        isModal={true}
                        button={
                            {
                                isBtn: false,
                                content: <div className={"access-messenger"}> <Icon type={"chat-webcam"} className={"icon-chat"} /></div>,
                                className: "btn-profile-subnav primary-reverse chat-webcam"
                            }
                        }
                    />

                    <Link className={"access-messenger"} to={createLink("signup")}>
                        <Icon type={"speech-bubbles"}/>
                        {messengerTotal > 0 && <div
                            className={`notifications-count ${this.state.messengerClass}`}>{messengerTotal > 99 ? '99+' : messengerTotal}</div>}
                    </Link>

                    <Dropdown className="notification-dropdown" align="right"
                              handleToggleChildren={this.props.handleToggleNotification}
                              toggleStatus={this.props.toggleNotif}
                              activableComponent={(
                                  <div className="notifications">
                                      <Icon type="bell"/>
                                      {notificationsTotal > 0 && <div
                                          className={`notifications-count ${this.state.notificationClass}`}>{notificationsTotal > 99 ? '99+' : notificationsTotal}</div>}
                                  </div>
                              )}>
                        <div className="topline-notification-dropdown">
                            <div className="title">Notifications</div>
                            <div className="options-dropdown">
                                <div className="read-all">Tout marquer comme lu</div>
                                -
                                <Link to={createLink("userMeSettingsOptionsNotifications")}>
                                    <div className="settings" onClick={() => this.props.handleCloseDropdown()} >Paramètres</div>
                                </Link>
                            </div>
                        </div>
                        <FakeNotificationsList
                            handleCloseDropdown={()=>this.props.handleCloseDropdown}
                            notificationTotal={notificationsTotal}
                            notifications={notifications}
                        />
                    </Dropdown>

                </Fragment>
            ) : null
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FakeNotifications);

